import { Stack } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import { Text } from '@feathr/components';
import Page from '@feathr/extender/App/Page';

import CampaignBreakdownCard from './CampaignBreakdownCard';
import CurrentBillingPeriodCard from './CurrentBillingPeriodCard';
import useEmailLimitsPermissions from './EmailLimitsPage.useEmailLimitsPermissions';
import MonthlyBreakdownCard from './MonthlyBreakdownCard';

function EmailLimitsPage(): JSX.Element {
  const { canViewMonthlyBreakdown, canViewCampaignBreakdown } = useEmailLimitsPermissions();

  return (
    <Page
      actions={
        <Text.DefaultLink
          href={
            'https://help.feathr.co/hc/en-us/articles/35489824875927-About-Email-Overage-Automatic-Billing'
          }
          target={'_blank'}
        >
          Learn about auto-billing
        </Text.DefaultLink>
      }
    >
      <Stack>
        <CurrentBillingPeriodCard />

        {canViewCampaignBreakdown && <CampaignBreakdownCard />}

        {canViewMonthlyBreakdown && <MonthlyBreakdownCard />}
      </Stack>
    </Page>
  );
}

export default EmailLimitsPage;
